module.exports = __webpack_public_path__ + "img/coingecko-logo.9097d0f1.png";